var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('icon-button',{attrs:{"icon":_vm.icon,"tooltip":_vm.labels.tooltip,"align-tooltip-left":_vm.isLeft,"aria-label":_vm.labels.ariaLabel},on:{"click":_vm.toggleFullScreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }